export default {
  common: {
    loading: '載入中',
    confirm: '確認',
    cancel: '取消',
    save: '儲存',
    back: '返回',
    copy: '複製',
    delete: '刪除',
    copySuccess: '複製成功',
    editSuccess: '編輯成功',
    deleteSuccess: '刪除成功',
    modifySuccess: '修改成功',
    cannotBeEmpty: '不能為空',
    noContent: '暫無內容',
    noData: '暫無相關資料',
    noMoreData: '沒有更多資料了',
    iKnow: '我知道了',
    selectService: '選擇服務商',
    sendSuccess: '發送成功',
  },
  billHome: {
    recharge: '儲值繳費服務',
    coupon: '優惠券',
    rechargeNow: '立即儲值',
    cost: '話費',
    flow: '流量',
    rechargeNotice: '儲值須知',
    rechargeCost: '話費儲值',
    rechargeFlow: '流量儲值',
    rechargeAmount: '儲值金額',
    rechargePackage: '儲值方案',
    discount: '已折扣',
    confirmTxt: '確認無誤',
    confirmTxt1: '我知道了',
    actualPayment: '實付金額',
    selectCoupon: '選擇優惠券',
    useRule: '使用規則',
    availableCoupon: '可用優惠券',
    unavailableCoupon: '不可用優惠券',
    noAvailableCoupon: '暫無可用優惠券',
    selectPhone: '選擇手機號碼',
    pleaseInputPhone: '請輸入手機號碼',
    couponCount: '張可用',
    pleaseInputCorrectPhone: '請輸入正確的手機號碼',
    pleaseSelectPackage: '請選擇充值套餐',
  },
  accountManage: {
    title: '帳號管理',
    edit: '編輯',
    deleteConfirm: '確認刪除',
  },
  rechargeDetail: {
    title: '繳費明細',
    continuePay: '繼續付款',
  },
  feesExpense: {
    title: '繳費紀錄',
    recharge: '手機費',
    electricity: '電費',
    internet: '網費',
    water: '水費',
    photo: '拍照',
    complete: '完成',
    manage: '管理',
    allSelect: '全選',
    selected: '已選擇',
    deleteConfirm: '確認刪除',
    deleteRecord: '筆繳費紀錄？',
    noDataAction: '暫無可操作資料',
    pleaseSelect: '請先選擇要刪除的紀錄',
    feesNotice: '繳費須知',
  },
  formCom: {
    upload: '點擊上傳',
    saveAccount: '儲存或更新現有帳號',
    createOrder: '建立訂單',
    rechargeIng: '儲值中',
    rechargeNow: '立即儲值',
    serviceProvider: '服務商',
    billImage: '帳單圖片',
    returnSelect: '返回重新選擇',
    electricity: '電費繳納',
    internet: '網路費繳納',
    water: '水費繳納',
    photo: '拍照繳費',
    life: '生活繳費',
    uploadFail: '上傳失敗，請重試',
    pleaseFill: '請填寫完整資訊',
    submitSuccess: '提交成功，請等待付款',
  },
  langPop: {
    selectLang: '選擇語言',
  },
  loginPop: {
    loginOrRegister: '請登入或註冊筷子帳號',
    confirmLogout: '確定要登出嗎？',
    toLogin: '前往登入',
    logoutSuccess: '登出成功',
  },
  newMe: {
    myOrder: '我的訂單',
    coupon: '優惠券',
    accountManage: '帳號管理',
    orderCount: '筆訂單進行中',
    couponCount: '張',
    account: '帳戶',
    logout: '登出',
  },
  coupons: {
    all: '全部',
    coupon: '優惠券',
    historyCoupon: '歷史優惠券',
    use: '去使用',
    validityPeriod: '有效期限',
    useRule: '使用規則',
    used: '已使用',
    expired: '已過期',
  },
  accountSeting: {
    title: '設定',
    personalInfo: '個人資料',
    modifyPayPassword: '修改付款密碼',
    modifyLoginPassword: '修改登入密碼',
    phone: '手機號碼',
    code: '驗證碼',
    loginPassword: '登入密碼',
    confirmModify: '確認修改',
    noCode: '收不到驗證碼？',
    passwordPlaceholder: '密碼需為8~16位數字加字母組合',
    inputCorrectPhone: '請輸入正確手機號碼',
    afterGetCode: '後可再次取得',
    getCode: '取得驗證碼',
    input6DigitPassword: '請輸入6位數字密碼',
    twoInputPasswordNotConsistent: '兩次輸入的密碼不一致',
    placeholderCode: '請輸入驗證碼',
    confirmPassword: '確認密碼',
    password: '密碼',
    submit: '送出',
    avatar: '頭像',
    userName: '使用者名稱',
    nickName: '暱稱',
    modifyPhone: '修改手機號碼',
    nickNamePlaceholder: '成為有風格的人',
    sex: '性別',
    male: '男',
    female: '女',
    email: '電子信箱',
    emailPlaceholder: '設定Email以便找回密碼',
    pleaseCompletePersonalData: '請完善個人資料，以體驗更多功能',
    bindNewPhone: '綁定新手機號碼',
    oldPhone: '舊手機號碼',
    completeVerification: '完成驗證',
    changePayPasswordTitle: '修改支付密碼',
    changePasswordTitle: '修改登入密碼',
    oldPhoneTitle: '驗證舊手機號碼',
    editInfoTitle: '編輯個人資料',
    areaCode: '區號',
  },
}
